import $ from 'jquery';
import Filterable from '../components/filterable';

class People {
    constructor() {
        this.initialize();
    }

    initialize() {
        Filterable.init();
    }

    static init() {
        if ($('.people').length > 0) {
            new People();
        }
    }
}

export default People;
